import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class DashboardDeleteModalController implements angular.IComponentController {
    readonly onDelete: ({ guid: string }) => void;
    readonly selectedItem: any; //Type to be determined

    static $inject = [];

    deleteItem(guid: string): void {
        if (this.onDelete) {
            this.onDelete({ guid });
        }
    }
}

export const wtDashboardDeleteModal: ComponentDefinition = {
    componentId: 'wtDashboardDeleteModal',
    controller: DashboardDeleteModalController,
    template: require('./dashboardDeleteModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        onDelete: '&?',
        selectedItem: '<'
    }
};
